module.exports = __webpack_public_path__ + "img/67800.1b30a138.jpg";